import { generateKeys, generateLocalization } from '../utils';
export const prizes = generateLocalization('prizes', generateKeys({
    cashPrize: {
        value: 'cashPrize',
        label: 'Cash prize',
        localization: { id: '', defaultMessage: '' },
        depositAmount: 500,
    },
    smartphone: {
        value: 'smartphone',
        label: 'Smartphone',
        localization: { id: '', defaultMessage: '' },
    },
    laptop: {
        value: 'laptop',
        label: 'Laptop',
        localization: { id: '', defaultMessage: '' },
    },
    tripToCyprus: {
        value: 'tripToCyprus',
        label: 'Trip to Cyprus/visit to HQs',
        localization: { id: '', defaultMessage: '' },
    },
    luxuryWatch: {
        value: 'luxuryWatch',
        label: 'Luxury watch',
        localization: { id: '', defaultMessage: '' },
    },
    tripForTwoToLasVegas: {
        value: 'tripForTwoToLasVegas',
        label: 'Trip for 2 to Las Vegas',
        localization: { id: '', defaultMessage: '' },
    },
    luxuryMotorcycle: {
        value: 'luxuryMotorcycle',
        label: 'Luxury Motorcycle',
        localization: { id: '', defaultMessage: '' },
    },
    sportsCar: {
        value: 'sportsCar',
        label: 'Sports car',
        localization: { id: '', defaultMessage: '' },
    },
    superCar: {
        value: 'superCar',
        label: 'Super car',
        localization: { id: '', defaultMessage: '' },
    },
}));
